import SearchOption from 'eop-ui-core/models/SearchOption'
import repository from '@/api'
import ManualArticle, { CoverImageItem } from '@/models/ManualArticle'
import utils from '@/utils'

const URI = `/v1/manual-articles`
export default {
  findManualArticles({ manualNo, headingId, pageNoKeyword }) {
    const queryString = new SearchOption({ condition: { manualNo, headingId, pageNoKeyword } }).toQueryString()
    return repository.get(`${URI}${queryString}`)
  },
  registerManualArticle(manualNo: string, manualArticle: ManualArticle, uploadedImage: File) {
    return repository.post(`/v1/manuals/${manualNo}/articles`, new ManualArticleOfCreation(manualArticle).buildFormData(uploadedImage))
  },
  modifyManualArticle(manualArticleId: string, manualArticle: any, uploadedImage: File) {
    return repository.patch(`${URI}/${manualArticleId}`, new ManualArticleOfModification(manualArticle).buildFormData(uploadedImage))
  },
  removeManualArticle(manualArticleId: string) {
    return repository.delete(`${URI}/${manualArticleId}`, undefined)
  },
}

class ManualArticleOfModification {
  title: string
  content: string
  coverImage?: CoverImageItem
  order?: number
  constructor(props: any) {
    this.title = props.title
    this.content = props.content
    this.order = props.order
    if (props.coverImage?.imageId) {
      this.coverImage = { imageId: props.coverImage.imageId }
    }
  }
  buildFormData(uploadedImage: File, props?) {
    this.coverImage = uploadedImage ? { imageIndex: 0 } : this.coverImage
    return utils.buildFormData(
      {
        title: this.title,
        content: this.content,
        coverImage: this.coverImage,
        order: this.order,
        ...(props || {}),
      },
      { image: uploadedImage },
    )
  }
}

class ManualArticleOfCreation extends ManualArticleOfModification {
  headingId?: string
  pageNo?: string
  constructor(props: any) {
    super(props)
    this.headingId = props.headingId
    this.pageNo = props.pageNo
  }
  buildFormData(uploadedImage: File) {
    return super.buildFormData(uploadedImage, {
      headingId: this.headingId,
      pageNo: this.pageNo,
    })
  }
}
